import { PERMISSIONS } from '@vindr/services/constants/permissions.constant';
import keycloak from '@vindr/services/keycloak';
// import CloseOutlined from '@ant-design/icons/CloseOutlined';
import { PaperClipOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { StateReportParams } from './ReportForm';

const OpenWebcamButton = ({
  recordVideo,
  setRecordVideo,
  warningCloseCamera,
}: StateReportParams) => {
  const { t } = useTranslation('Vindoc');

  const handleCaptureVideo = () => {
    const onClose = () => {
      setRecordVideo((draft) => {
        draft.open = !recordVideo.open;
        draft.recording = false;
      });
    };

    if (!recordVideo.recording && !recordVideo.open) {
      setRecordVideo((draft) => {
        draft.open = true;
      });
      return;
    }

    if (!recordVideo.recording && recordVideo.open) {
      setRecordVideo((draft) => {
        draft.open = false;
        draft.recording = false;
      });
      return;
    }

    if (recordVideo.recording && recordVideo.open) {
      return warningCloseCamera(onClose);
    }
  };

  if (keycloak.hasOneOfPerm([PERMISSIONS.report.capture])) {
    return (
      <Button
        size="small"
        className="mt-1 mr-2 flex items-center"
        onClick={handleCaptureVideo}
        disabled={recordVideo.open}
      >
        <PaperClipOutlined />
        {t('Attach')}
      </Button>
    );
  }

  return null;
};

export default OpenWebcamButton;
